import React, { PropTypes } from 'react';
import OrdersGroup from './OrdersGroup';
import { gettext } from '../../i18n/service.js';
import { OrdersFilterComponent } from './ordersFilter/OrdersFilterComponent';
import { searchOrders } from '../../businessLogic/onDemandOrdersFilter';
import { HistoryOrdersGroup } from './HistoryOrdersGroup';

export class SidebarOrdersComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { orders, companyOrders, actions, state, recipients, pickUpPoints, drivers, companyId, users, vehicles, router, dashboardPageActions } = this.props;
    const { newOrders, inProgress, history } = searchOrders(orders, state.ordersFilter.searchEntered);

    return (
      <div>
        <OrdersFilterComponent actions={actions} state={state.ordersFilter} orders={orders} companyId={companyId}/>
        <OrdersGroup title={gettext('ORDER.NEW-ORDERS')} orders={newOrders}
          orderType="new"
          isOpen={state.newOrdersExpand.isOpen} toggle={actions.toggleNewOrders}
          startDraggingOrder={this.props.startDraggingOrder}
          draggingOrder={this.props.draggingOrder}
          pickUpPoints={pickUpPoints}
          recipients={recipients}
          drivers={drivers}
          handleOrderSelectChange={this.props.handleOrderSelectChange}
          orderClick={this.props.orderClick}
          ordersSelectedOnTable={this.props.ordersSelectedOnTable}
          showMessage={this.props.showMessage}
          clearSelectedOrders={this.props.clearSelectedOrders}
          users={users} vehicles={vehicles} router={router} appActions = {this.props.appActions}
          dashboardPageActions = {this.props.dashboardPageActions}
          renderModalForDetails={this.props.renderModalForDetails}
          originalOrders={companyOrders} />
        <OrdersGroup title={gettext('ORDER.IN-PROGRESS')} orders={inProgress}
          isOpen={state.inProgressOrdersExpand.isOpen}
          orderType="inProgress"
          toggle={actions.toggleInProgressOrders} pickUpPoints={pickUpPoints}
          recipients={recipients}
          drivers={drivers}
          showMessage={this.props.showMessage}
          handleOrderSelectChange={this.props.handleOrderSelectChange}
          orderClick={this.props.orderClick}
          ordersSelectedOnTable={this.props.ordersSelectedOnTable}
          clearSelectedOrders={this.props.clearSelectedOrders}
          users={users} vehicles={vehicles} router={router} appActions = {this.props.appActions}
          dashboardPageActions = {this.props.dashboardPageActions}
          renderModalForDetails={this.props.renderModalForDetails}
          originalOrders={companyOrders} />
        {/*<HistoryOrdersGroup title={gettext('ORDER.HISTORY')} orders={history}
          isOpen={state.historyOrdersExpand.isOpen}
          toggle={actions.toggleHistoryOrders}
          drivers={drivers}
          renderModalForDetails={this.props.renderModalForDetails}>
        </HistoryOrdersGroup>*/}
      </div>
    );
  }
}
SidebarOrdersComponent.propTypes = {
  orders: PropTypes.array,
  companyOrders: PropTypes.array,
  recipients: PropTypes.array,
  pickUpPoints: PropTypes.object,
  drivers: PropTypes.array,
  users: PropTypes.array,
  vehicles: PropTypes.array,
  router: PropTypes.object,
  appActions: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/SidebarOrdersComponent.js